$(function(){
  $(document).on("click", ".faq-item__top", function(){
    $(this).siblings(".faq-item__bottom").slideToggle(200);
    $(this).closest(".faq-item").toggleClass("is-active");
  })
});